export const StockTypeEnumDisplay = [
    { name: "STOCK", displayVal:'STOCK'},
    { name:'RECLASSIFICATION', displayVal:'RECLASSIFICATION'}
]

export enum StockTypeEnum {
    STOCK = 'STOCK',
    RECLASSIFICATION = 'RECLASSIFICATION',

}